import { apiClient } from '@/lib/api';
export const adminApi = {
    metrics: () => apiClient.get('/admin/metrics'),
    orgs: () => apiClient.get('/admin/orgs'),
    org: (id) => apiClient.get(`/admin/orgs/${id}`),
    subscriptions: () => apiClient.get('/admin/subscriptions'),
    users: () => apiClient.get('/admin/users'),
    user: (id) => apiClient.get(`/admin/users/${id}`),
    resellers: () => apiClient.get('/admin/resellers'),
    commissions: () => apiClient.get('/admin/commissions'),
    payouts: () => apiClient.get('/admin/payouts'),
    featureFlags: () => apiClient.get('/admin/feature-flags'),
    toggleFlag: (key, enabled) => apiClient.patch(`/admin/feature-flags/${key}`, { enabled }),
    audit: () => apiClient.get('/admin/audit'),
    staff: () => apiClient.get('/admin/staff'),
    createStaff: (b) => apiClient.post('/admin/staff', b),
    updateStaff: (id, b) => apiClient.patch(`/admin/staff/${id}`, b),
    deleteStaff: (id) => apiClient.delete(`/admin/staff/${id}`),
    impersonate: (orgId) => apiClient.post(`/admin/impersonate/${orgId}`),
    platformCloudflare: () => apiClient.get('/admin/platform/cloudflare'),
    savePlatformCloudflare: (b) => apiClient.put('/admin/platform/cloudflare', b),
    testPlatformCloudflare: () => apiClient.post('/admin/platform/cloudflare/test', {}),
    platformEmail: () => apiClient.get('/admin/platform/email'),
    savePlatformEmail: (b) => apiClient.put('/admin/platform/email', b),
    testPlatformEmail: (recipient) => apiClient.post('/admin/platform/email/test', { recipient }),
};
